module.exports = __webpack_public_path__ + "img/MG-TITLE-02.f7cad805.png";